<input type="hidden" name="menuType" id="menuType" value="secure" />
<div class="ontario-row">
  <div class="ontario-column ontario-small-12">
    <h2 id="pageTitle">{{'bss.noService.title'| translate}}</h2>
    <hr>
  </div>
</div>


<div class="ontario-row">
  <div class="ontario-column ontario-small-12">

      <p>{{'bss.noService.subTitle'| translate}}</p>

      <p>{{'bss.noService.subTitle.2'| translate}}</p>
      <button tabindex="102" class="ontario-button ontario-button--primary" (click)="viewProfile()"
        title=" {{'bss.noService.goback.title' | translate }}">
        {{'bss.noService.goback' | translate }}
      </button>

  </div>
</div>